
export const CARD_ICON_SIZE = 54;
export const CARD_ICON_TOP_OFFSET = CARD_ICON_SIZE - 45;
export const CARD_PADDING_TOP = 36;
